import { PageLayout, Section } from "../components/PageLayout";
import { WideOpener, AtmoBreak, SideBySide } from "../components/ImageBlocks";
import { useLanguage } from "../contexts/LanguageContext";

export default function BeASocialSeller() {
  const { t } = useLanguage();
  return (
    <PageLayout>
      <WideOpener
        src="wide-3-0_haltung_21-9_v01.jpg"
        alt={t("menuSocialSeller")}
        heading={t("menuSocialSeller")}
      />

      <div
        className="mx-auto w-full max-w-3xl text-[17px] leading-[1.6] sm:text-[18px]"
        style={{ color: "#1A1A1A" }}
        data-testid="page-social-seller-intro"
      >
        <SideBySide src="IST_umarmung_q_v01.jpg" alt="">
          <p>{t("ss_intro_1")}</p>
          <p>{t("ss_intro_2")}</p>
          <p>{t("ss_intro_3")}</p>
          <p>{t("ss_intro_4")}</p>
          <p>{t("ss_intro_5")}</p>
          <p>{t("ss_intro_6")}</p>
          <p>{t("ss_intro_7")}</p>
        </SideBySide>
      </div>

      {/* 3.1 — Was ist ein Social Seller. 16:9 nach dem 4. Textabsatz (nicht am Ende) */}
      <WideOpener
        src="wide-3-1_klarheit_21-9_v01.jpg"
        alt={t("ss_31_heading")}
        heading={t("ss_31_heading")}
      />

      <Section testId="section-was-ist">
        <SideBySide src="IST_huegel_q_v01.jpg" alt="">
          <p>{t("ss_31_p1")}</p>
          <p>{t("ss_31_p2")}</p>
          <p>{t("ss_31_p3")}</p>
          <p>{t("ss_31_p4")}</p>
          <AtmoBreak src="3-0_vision_16_v01.jpg" alt="" />
          <p>{t("ss_31_p5")}</p>
          <p>{t("ss_31_p6")}</p>
          <p>{t("ss_31_p7")}</p>
          <p className="border-l-2 pl-5 italic" style={{ borderColor: "#2A2624" }}>
            {t("ss_31_quote")}
          </p>
        </SideBySide>
      </Section>

      {/* 3.2 — Warum Social Selling heute wichtiger ... 16:9 unter den 2. Absatz */}
      <WideOpener
        src="wide-3-2_tiefe-haltung_21-9_v01.jpg"
        alt={t("ss_32_heading")}
        heading={t("ss_32_heading")}
      />

      <Section testId="section-warum-heute">
        <SideBySide src="IST_stadt_q_v01.jpg" alt="">
          <p>{t("ss_32_p1")}</p>
          <p>{t("ss_32_p2")}</p>
          <AtmoBreak src="3-1_richtung_16_v01.jpg" alt="" />
          <p>{t("ss_32_p3")}</p>
          <p>{t("ss_32_p4")}</p>
        </SideBySide>
      </Section>

      {/* 3.3 — Der wichtigste Satz der Seite. 16:9 ganz raus */}
      <WideOpener
        src="wide-3-3_oeffnung_21-9_v01.jpg"
        alt={t("ss_33_heading")}
        heading={t("ss_33_heading")}
      />

      <Section testId="section-wichtigster-satz">
        <SideBySide src="IST_kreis_q_v01.jpg" alt="">
          <p className="border-l-2 pl-5 italic" style={{ borderColor: "#2A2624" }}>
            {t("ss_33_quote")}
          </p>
          <p>{t("ss_33_p1")}</p>
          <p>{t("ss_33_p2")}</p>
        </SideBySide>
      </Section>

      {/* 3.4 — Was Social selling nicht ist. 16:9 komplett raus */}
      <WideOpener
        src="wide-3-4_resonanz_21-9_v01.jpg"
        alt={t("ss_34_heading")}
        heading={t("ss_34_heading")}
      />

      <Section testId="section-nicht-ist">
        <SideBySide src="IST_fluss_q_v01.jpg" alt="">
          <p>{t("ss_34_p1")}</p>
          <p>{t("ss_34_p2")}</p>
        </SideBySide>
      </Section>

      {/* 3.5 — Was du brauchst um Social seller zu sein. 16:9 raus */}
      <WideOpener
        src="wide-3-5_reife_21-9_v01.jpg"
        alt={t("ss_35_heading")}
        heading={t("ss_35_heading")}
      />

      <Section testId="section-was-brauchst">
        <SideBySide src="IST_stadion_q_v01.jpg" alt="">
          <p>{t("ss_35_p1")}</p>
          <p>{t("ss_35_p2")}</p>
        </SideBySide>
      </Section>

      {/* 3.6 — Erster Schritt. 16:9 bleibt */}
      <WideOpener
        src="wide-3-6_weite-haltung_21-9_v01.jpg"
        alt={t("ss_36_heading")}
        heading={t("ss_36_heading")}
      />

      <Section testId="section-erster-schritt">
        <SideBySide src="IST_suchende_q_v01.jpg" alt="">
          <p>{t("ss_36_p1")}</p>
          <p>{t("ss_36_p2")}</p>
        </SideBySide>
        <AtmoBreak src="3-5_naehe_16_v01_v1.jpg" alt="" />
      </Section>
    </PageLayout>
  );
}
